
import { defineStore } from 'pinia';
import { api } from 'boot/axios'
import { useRoute, useRouter } from "vue-router";

export const useincidentsStore = defineStore('incidents', {
  state: () => ({
    user: null,
    incidents: [],
    selectedincident: {},
    serviceProviders: [],
    stats: {
      new: 1,
      inProgress: 3,
      closed: 2,
    },
    channels: [],
    categories: [],
    states: [
      { id: 'new' },
      { id: 'review' },
      { id: 'notApproved' },
      { id: 'approved' },
      { id: 'waitingOnWhistleblower' },
      { id: 'replied' },
      { id: 'waitingOnResearch' },
      { id: 'done' },
      { id: 'archived' },
    ],
    config: null,// { design: {}, legal: {}, defaultTexts: [] }
    pk: null,
  }),
  getters: {
    mainCategories() {
      return this.categories.filter(c => !c.parent && c._id > 1).map((c) => {
        c.subCategories = this.categories.filter((sc) => sc.parent == c._id);
        return c;
      });
    },
    hasPK() {
      return !!this.pk;
    }
  },
  actions: {

    getChats(sender) {
      if (sender == 'user')
        return this.selectedincident.chat;
      // todo: do this on the server side!
      return this.selectedincident.chat.filter(c => !c.private);
    },
    checkServiceProvider(tenant, serviceProviderId) {
      return api.post('?tenant=' + tenant + '&datatype=config&method=csp',
        {
          serviceProviderId: serviceProviderId
        })
        .catch(() => {
          return Promise.reject();
        })
        .then((data) => {
          return Promise.resolve(data.data);
        });
    },
    removeServiceProvider(tenant, id) {
      return api.post('?tenant=' + tenant + '&datatype=config&method=dsp', {
        id: id
      }).then(() => this.loadServiceProviders(tenant));
    },
    addServiceProvider(tenant, serviceProviderId) {
      return api.post('?tenant=' + tenant + '&datatype=config&method=asp',
        {
          serviceProviderId: serviceProviderId
        })
        .catch(() => {
          return Promise.reject();
        })
        .then((data) => {
          return this.loadServiceProviders(tenant);
        });
    },
    setState(tenant, state, sender, text, prop) {

      const data = [];
      if (text)
        data.push(text);

      return this.comment(tenant, data,
        {
          state: state,
          sender: sender,
          private: false,
          defaultTextProp: prop
        });
    },
    comment(tenant, data, options) {

      let comment = {
        incidentId: this.selectedincident._id,
        id: this.selectedincident.chat.length,
        text: data
      };
      comment = Object.assign(comment, options);
      return api.post('?tenant=' + tenant + '&datatype=incidents&method=comment',
        comment)
        .catch(() => {
          return Promise.reject();
        })
        .then((data) => {
          return this.load(tenant, data.data._id, options.sender);
        });
    },
    saveUser(tenant, options) {
      return api
        .post(
          "?tenant=" +
          tenant +
          "&method=iu&datatype=users",
          Object.assign({
            _id: this.user._id,
          }, options)
        )
        .then((data) => {
          this.user = data.data;
          return Promise.resolve();
        });
    },
    save(tenant, id, options, sender) {
      return api
        .post(
          "?tenant=" +
          tenant +
          "&method=update&datatype=incidents",
          Object.assign({
            _id: id,
          }, options)
        )
        .then((data) => {
          return this.load(tenant, data.data._id, sender);
        });
    },
    addNote(tenant, data) {
      return this.comment(tenant, data, {
        state: this.selectedincident.state,
        sender: "user",
        private: true,
      });
    },
    loadConfig(tenant) {
      return api.get('?tenant=' + tenant + '&method=g&_id=1&datatype=config')
        .catch(() => {
          location.hash = '/' + tenant + '/setup';
          return Promise.reject();
        })
        .then((data) => {

          this.config = data.data;

          return Promise.resolve(this.config);
        });
    },
    loadChannels(tenant) {
      return api.get('?tenant=' + tenant + '&method=l&datatype=channels')
        .catch(() => {
          this.channels = [];

          return Promise.reject();
        })
        .then((data) => {

          this.channels = data.data.map((c) => {
            if (c._id != 1) {
              c.url = 'channel/' + c._id + '/';
            } else {
              c.url = '';
            }
            return c;
          });

          return Promise.resolve(this.channels);
        });
    },
    loadChannel(tenant, id) {
      if (!id)
        id = 1;

      return api.get('?tenant=' + tenant + '&method=g&datatype=channels&_id=' + id)
        .catch(() => {
          return Promise.reject(null);
        })
        .then((data) => {
          return Promise.resolve(data.data);
        });
    },
    saveChannel(tenant, channel) {
      return api.post('?tenant=' + tenant + '&method=iu&datatype=channels', channel);
    },
    loadUsers(tenant) {
      return api.get('?tenant=' + tenant + '&method=l&datatype=users')
        .catch(() => {
          location.hash = '/' + tenant + '/setup';
          return Promise.reject();
        })
        .then((data) => {

          this.users = data.data;

          return Promise.resolve(this.users);
        });
    },
    saveConfig(tenant) {
      return api.post('?tenant=' + tenant + '&method=iu&datatype=config', this.config);
    },
    loadStats(tenant) {

      return api.get('?tenant=' + tenant + '&method=l&datatype=stats')
        .then((data) => {

          return Promise.resolve(data.data);
        });
    },
    loadServiceProviders(tenant) {

      return api.get('?tenant=' + tenant + '&method=lsp&datatype=config')
        .catch(() => {
          return Promise.reject();
        })
        .then((data) => {

          this.serviceProviders = data.data;
          return Promise.all(data.data);
        });
    },
    loadTenantsStats(tenant) {

      return api.get('?tenant=' + tenant + '&method=l&datatype=tenants')
        .catch(() => {
          return Promise.reject();
        })
        .then((data) => Promise.all(data.data.map(c => this.loadStats(c.tenant))));

    },
    manageAccess(tenant, incidentId, assignedTo, password) {
      return api.post('?tenant=' + tenant + '&method=manageAccess&datatype=incidents', {
        incidentId: incidentId,
        password: password,
        assignedTo: assignedTo
      }).catch(() => {
        return Promise.reject();
      }).then(() => {
        return Promise.resolve();
      });
    },
    validateAccess(tenant, incidentId, password) {
      return api.post('?tenant=' + tenant + '&method=check&datatype=incidents', {
        incidentId: incidentId,
        password: password
      }).catch(() => {
        return Promise.reject();
      }).then(() => {
        return Promise.resolve();
      });
    },
    login(tenant, username, password, twoFactorInput) {
      const parameters = {
        username: username,
        password: password
      };
      if (twoFactorInput) {
        parameters.twoFactor = twoFactorInput;
      }
      return api.post('?tenant=' + tenant + '&method=login&datatype=users',
        parameters).catch(() => {
          this.user = null;
          return Promise.reject();
        }).then((data) => {
          this.user = data.data;
          return Promise.resolve();
        });
    },
    getTmpTwoFactorSecret(tenant) {
      return api.post('?tenant=' + tenant + '&method=2f&datatype=users')
        .catch(() => {
          return Promise.reject(null);
        }).then((data) => {
          return Promise.resolve(data.data);
        });
    },
    confirmTmpTwoFactor(tenant, key) {
      return api.post('?tenant=' + tenant + '&method=confirm_2f&datatype=users', {
        key: key
      })
        .catch(() => {
          return Promise.reject(null);
        }).then((data) => {
          return Promise.resolve();
        });
    },
    removeTwoFactor(tenant, password) {
      return api.post('?tenant=' + tenant + '&method=remove_2f&datatype=users', {
        password: password
      })
        .catch(() => {
          return Promise.reject(null);
        }).then((data) => {
          return Promise.resolve();
        });
    },
    loadLoggedinUser(tenant) {
      return api.post('?tenant=' + tenant + '&method=loggedin&datatype=users')
        .catch(() => {
          this.user = null;
          return Promise.reject(this.user);
        }).then((data) => {
          this.user = data.data;
          return Promise.resolve(this.user);
        });
    },
    logout(tenant) {
      return api.post('?tenant=' + tenant + '&method=logout&datatype=users').then(() => {
        window.location.reload();
      });
    },
    setpassword(tenant, userId, password) {
      return this.resetpassword(tenant, userId, password, null);
    },
    resetpassword(tenant, userId, password, passOrAcountRecoveryKey) {
      return api.post('?tenant=' + tenant + '&method=resetpassword&datatype=users', {
        userId: userId,
        password: password,
        auth: passOrAcountRecoveryKey,
      });
    },
    confirmPassword(tenant, password) {
      return api.post('?tenant=' + tenant + '&method=confirmpassword&datatype=users', {
        password: password,
      });
    },
    changePassword(tenant, newPassword, auth) {
      return this.resetpassword(tenant, this.user._id, newPassword, auth);
    },
    loadList(tenant, t) {

      // this.incidents = internalincidents.map(i => {
      //   return {
      //     internalId: i.internalId,
      //     id: i.id,
      //     state: i.state,
      //     deadline: i.deadline,
      //     subject: i.subject,
      //     category: i.category
      //   };
      // });

      return Promise.all([
        this.loadConfig(tenant),
        this.loadCategories(tenant),
        this.loadChannels(tenant),
        api.get('?tenant=' + tenant + '&datatype=incidents&method=l')
          .then((data) => {

            this.incidents = data.data.map(incident => {
              incident.channelName = '';
              incident.displayId = (incident._id + "").match(/(.{1,4})/g).join('-');

              let channel = null;

              if (!incident || !incident.channel) {
                channel = this.channels.find((c) => c._id == 1);
              } else {
                channel = this.channels.find((c) => c._id == incident.channel);
              }
              if (channel) {
                incident.channelName = channel["name" + t("ls")];
              }

              return incident;
            });


            return Promise.resolve(this.incidents);
          })
      ]);
    },

    loadVaDokDocu(tenant, type) {

      return api.get('?tenant=' + tenant + '&method=l&datatype=docu&type=' + type)
        .then((data) => {
          return Promise.resolve(data.data);
        });
    },
    validatePassword(password) {
      // Define regular expressions for character types
      const lowercaseRegex = /[a-z]/;
      const uppercaseRegex = /[A-Z]/;
      const numberRegex = /[0-9]/;
      const specialCharRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/;

      // Check the length
      if (password.length < 12) {
        return false;
      }

      // Check for lowercase letters
      if (!lowercaseRegex.test(password)) {
        return false;
      }

      // Check for uppercase letters
      if (!uppercaseRegex.test(password)) {
        return false;
      }

      // Check for numbers
      if (!numberRegex.test(password)) {
        return false;
      }

      // Check for special characters
      if (!specialCharRegex.test(password)) {
        return false;
      }

      // If all checks pass, the password is valid
      return true;
    },
    loadAndSelect(tenant, id, sender) {

      return Promise.all([
        this.loadConfig(tenant),
        this.loadCategories(tenant),
        this.load(tenant, id, sender)
      ]);
    },
    load(tenant, id, sender) {
      // const config = this.password ? {
      //   auth: {
      //     username: 'whistleblower',
      //     password: this.password
      //   }
      // } : {};
      return api.get('?tenant=' + tenant + '&method=g&datatype=incidents&_id=' + id + '&sender=' + sender
        + (this.password ? '&p=' + btoa(this.password) : ''))
        .then((data) => {

          if (!data.data)
            return Promise.reject();

          this.selectedincident = data.data;
          this.selectedincident.displayId = (this.selectedincident._id + "").match(/(.{1,4})/g).join('-');
          return Promise.resolve(this.selectedincident);
        })
    },
    loadCategories(tenant) {

      return api.get('?tenant=' + tenant + '&method=l&datatype=category')
        .then((data) => {

          this.categories = data.data;
          return Promise.resolve(this.categories);
        });
    },
  },
});
